import { Box, Button, IconButton, Menu, MenuItem, Switch } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import SearchBar from '../../components/SearchBar';
import { showToast } from '../../constants/toasts';
import { BlogsList } from '../../features/blogs';
import { errorToast } from '../../helpers';
import MainContainer from '../../layout/MainContainer';
import { ConfirmationModal } from '../../Modals/confirmationModal';
import PromotionalDetailModal from '../../Modals/PromotionalDetailModal';
import {
  useDeleteBannerMutation,
  useLazyGetBannerQuery,
  useUpdateBannerMutation,
} from '../../service/banner';
import { BannerData, CommonBody } from '../../types/General';
import { generateEncryptedKeyBody } from '../../utils/crypto';
import { BANNER_TYPE } from '../../utils/enums';
import { isValidInput } from '../../utils/validations';

const PromotionalCampaign = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>('');
  const [openDetail, setOpenDetail] = useState(false);
  const [bannerData, setBannerData] = useState<BannerData[]>([]);
  const [banner, setBanner] = useState<BannerData>();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [totalCount, setTotalCount] = useState<number>();
  const [page, setPage] = useState<number>(1);
  const [selectedId, setSelectedId] = useState<string>('');
  const [openDelete, setOpenDelete] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  // const { isAdd, isDelete } = usePermission({
  //   label: "Promotional Campaigns",
  //   page_permission: "isView",
  // });

  const [hidden, setHidden] = useState<string[]>([]);
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);

  const [getBanner] = useLazyGetBannerQuery();
  const [deleteBanner] = useDeleteBannerMutation();
  const [updateBanner] = useUpdateBannerMutation();

  const handleClose = () => {
    setOpenDetail(false);
  };

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const open1 = Boolean(anchorEl1);

  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>, rowId: string) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(rowId);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };
  const label = { inputProps: { 'aria-label': 'Switch demo' } };

  const fetchBanner = async () => {
    setLoading(true);
    try {
      const res = await getBanner({
        page,
        limit: 10,
        search: debouncedSearchTerm?.trim(),
      }).unwrap();
      if (res?.statusCode === 200) {
        setBannerData(res?.data?.data);
        setTotalCount(res?.data?.count);
      }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteBanner = async () => {
    try {
      const res = await deleteBanner({ id: selectedId }).unwrap();
      if (res?.statusCode === 200) {
        showToast('Promotional campaign deleted successfully.');
        setBannerData((pre) => pre?.filter((itx) => itx?._id !== selectedId));
        setSelectedId('');
      }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.data?.message);
    }
  };

  const updateStatus = async (id: string, flag: boolean) => {
    try {
      const body = {
        isEnabled: flag,
      };
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const res = await updateBanner({ body: encryptedBody, id }).unwrap();
      if (res?.statusCode === 200) {
        showToast('Promotional campaign status change successfully.');
        setBannerData((prev) =>
          prev.map((banner) => (banner._id === id ? { ...banner, isEnabled: flag } : banner))
        );
      }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.data?.message);
    }
  };

  const columns: GridColDef<(typeof bannerData)[number]>[] = [
    {
      flex: 0.2,
      minWidth: 150,
      field: 'image',
      headerName: 'Campaign Image',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="sq_image">
            <figure>
              <img src={row?.image} alt="" />
            </figure>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 300,
      field: 'title',
      headerName: 'Title',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => (
        <div className="user_block">
          <p>{row?.name?.length > 30 ? `${row.name.slice(0, 30)}...` : row?.name || '-'}</p>
        </div>
      ),
    },
    {
      flex: 0.8,
      minWidth: 300,
      field: 'name',
      headerName: 'User Details',
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure
            // onClick={() =>
            //   navigate(`/profile-detail/individual/${row?.user?._id}`)
            // }
            >
              <img src={row?.user?.image || '/static/images/user_attachment.jpg'} alt="" />
            </figure>
            <p>
              <b>{row?.user?.name}</b> {`${row?.user?.dialCode || ''}${row?.user?.phoneNo || ''}`}{' '}
              <br />
              {row?.user?.email}
            </p>
          </div>
        );
      },
    },
    {
      flex: 0.8,
      minWidth: 200,
      field: 'bannerType',
      headerName: 'Banner Type',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            {BANNER_TYPE[row?.bannerType] || '-'}
            {/* <p onClick={() => window.open(row?.link, "_blank")}>{row?.link}</p> */}
          </div>
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 150,
      field: 'status',
      filterable: false,
      sortable: false,
      headerName: 'Block/Unblock',
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            checked={row?.isEnabled}
            onChange={() => updateStatus(row?._id, !row?.isEnabled)}
          />
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: 'action',
      headerName: 'Action',
      editable: false,
      sortable: false,
      renderCell: ({ row, id }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? 'basic-menu1' : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? 'true' : undefined}
                onClick={(e) => {
                  setBanner(row);
                  handleClick1(e, row?._id);
                }}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  'aria-labelledby': 'basic-button1',
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.05)',
                    borderRadius: '8px',
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                {/* <MenuItem
                  onClick={() => {
                    setOpenDetail(true);
                    handleClose1();
                  }}
                >
                  View
                </MenuItem> */}
                {/* {isAdd && */}

                <MenuItem
                  onClick={() => {
                    navigate(`edit/${selectedId}`);
                    handleClose1();
                  }}
                >
                  Edit
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    // navigate(`view/${selectedId}`);
                    handleClose1();
                    setOpenModal(true);
                  }}
                >
                  View
                </MenuItem>

                {/* } */}
                {/* {isDelete && */}

                <MenuItem
                  onClick={() => {
                    setOpenDelete(true);
                    setSelectedId(row?._id);
                  }}
                >
                  Delete
                </MenuItem>

                {/* } */}
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    fetchBanner();
  }, [page, debouncedSearchTerm]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1> Promotional Campaigns</h1>
        <p>
          <span onClick={() => navigate('/dashboard')}>Dashboard</span> - Promotional Campaigns
        </p>
      </div>

      <div className="cards">
        <Box className="custom_tabs" sx={{ width: '100%' }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm('')}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s">
              <Box>
                <Button className="btn btn_orange" onClick={() => navigate('add')}>
                  Add Campaign
                </Button>
              </Box>
            </div>
          </div>

          <BlogsList
            rows={bannerData}
            columns={columns}
            hidden={hidden}
            page={page}
            loading={loading}
            count={totalCount || 10}
            handlePageChange={handlePageChange}
          />
        </Box>
        {banner && (
          <PromotionalDetailModal
            open={openModal}
            setOpen={setOpenModal}
            onClose={handleClose}
            data={banner}
          />
        )}
        <ConfirmationModal
          text={'Are you sure to delete this Promotional Campaign ?'}
          openModal={openDelete}
          setOpenModal={setOpenDelete}
          handleSubmit={handleDeleteBanner}
        />
      </div>
    </MainContainer>
  );
};

export default PromotionalCampaign;
